import { ReactNode } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate, Link } from 'react-router-dom'
import { NotificationBell } from './NotificationBell'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await logout()
    navigate('/login')
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header
        style={{
          backgroundColor: '#343a40',
          color: 'white',
          padding: '15px 30px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h1 style={{ margin: 0, fontSize: '24px' }}>Reddit Autopilot</h1>
        {user && (
          <nav style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
            <Link to="/dashboard" style={{ color: 'white', textDecoration: 'none' }}>
              Dashboard
            </Link>
            <Link to="/campaigns" style={{ color: 'white', textDecoration: 'none' }}>
              Campaigns
            </Link>
            <Link to="/comments" style={{ color: 'white', textDecoration: 'none' }}>
              Comments
            </Link>
            <Link to="/analytics" style={{ color: 'white', textDecoration: 'none' }}>
              Analytics
            </Link>
            <Link to="/activity" style={{ color: 'white', textDecoration: 'none' }}>
              Activity
            </Link>
            <NotificationBell />
            <span style={{ color: '#adb5bd' }}>{user.email}</span>
            <button
              onClick={handleLogout}
              style={{
                padding: '5px 15px',
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Logout
            </button>
          </nav>
        )}
      </header>
      <main style={{ flex: 1, padding: '20px' }}>{children}</main>
    </div>
  )
}
